import React from "react";
import {
	FiFolder,
	FiInbox,
	FiFileText,
	FiExternalLink,
	FiUser,
	FiPlus,
	FiBriefcase,
	FiCalendar,
	FiStar,
	FiHeart,
	FiBookmark,
	FiHome,
	FiSettings,
	FiArchive,
	FiTag
} from "react-icons/fi";
import { documentsService } from "services";
import { toastr } from "react-redux-toastr";
import { withTranslation } from "react-i18next";

// Íconos que NO están siendo utilizados por las carpetas del sistema
// Sistema usa: payslips-icon (FiInbox), contracts-icon (FiFileText), absences-icon (FiExternalLink), personal-documents-icon (FiUser)
const iconOptions = [
	{ id: "briefcase-icon", icon: FiBriefcase, name: "Maletín" },
	{ id: "calendar-icon", icon: FiCalendar, name: "Calendario" },
	{ id: "star-icon", icon: FiStar, name: "Estrella" },
	{ id: "heart-icon", icon: FiHeart, name: "Corazón" },
	{ id: "bookmark-icon", icon: FiBookmark, name: "Marcador" },
	{ id: "home-icon", icon: FiHome, name: "Casa" },
	{ id: "settings-icon", icon: FiSettings, name: "Configuración" },
	{ id: "archive-icon", icon: FiArchive, name: "Archivo" },
	{ id: "tag-icon", icon: FiTag, name: "Etiqueta" },
	{ id: "folder-icon", icon: FiFolder, name: "Carpeta" },
];

class CreateFolderModal extends React.Component {
	constructor(props) {
		super(props);
		const { editMode, folderData } = props;

		this.state = {
			name: editMode ? folderData.name : "",
			description: editMode ? folderData.description : "",
			selectedIcon: editMode ? folderData.icon : "folder-icon",
			loading: false,
			editMode: editMode || false
		};
	}

	handleInputChange = (e) => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	};

	handleIconSelect = (iconId) => {
		this.setState({ selectedIcon: iconId });
	};

	handleSubmit = async (e) => {
		e.preventDefault();

		const { name, description, selectedIcon, editMode } = this.state;
		const { folderData, t } = this.props;

		if (!name.trim()) {
			toastr.error("Error", t("documents.folder.nameRequired"));
			return;
		}

		this.setState({ loading: true });

		try {
			const folderDataToSend = {
				name: name.trim(),
				description: description.trim(),
				icon: selectedIcon
			};

			if (editMode) {
				await documentsService.updateStoreFolder(folderData.id, folderDataToSend);
				toastr.success(t("common.success"), t("documents.folder.updated"));
			} else {
				await documentsService.createStoreFolder(folderDataToSend);
				toastr.success(t("common.success"), t("documents.folder.created"));
			}

			this.props.handleClose();
			this.props.onFolderCreated();
		} catch (error) {
			console.error("Error saving folder:", error);
			toastr.error("Error", editMode ? t("documents.folder.updateError") : t("documents.folder.createError"));
		} finally {
			this.setState({ loading: false });
		}
	};

	render() {
		const { name, description, selectedIcon, loading, editMode } = this.state;
		const { t } = this.props;

		return (
			<div className="create-folder-modal px-4 py-3">
				<form onSubmit={this.handleSubmit}>
					<div className="form-group mb-3">
						<label htmlFor="folderName" className="form-label">{t("documents.folder.name")} <span className="label-required">*</span></label>
						<input
							type="text"
							id="folderName"
							name="name"
							value={name}
							onChange={this.handleInputChange}
							className="form-control"
							placeholder={t("documents.folder.namePlaceholder")}
							required
							autoFocus
						/>
					</div>

					<div className="form-group mb-3">
						<label htmlFor="folderDescription" className="form-label">{t("documents.folder.description")}</label>
						<textarea
							id="folderDescription"
							name="description"
							value={description}
							onChange={this.handleInputChange}
							className="form-control"
							placeholder={t("documents.folder.descriptionPlaceholder")}
							rows="3"
						/>
					</div>

					<div className="form-group mb-4">
						<label className="form-label">{t("documents.folder.selectIcon")}</label>
						<div className="icon-gallery">
							{iconOptions.map((option) => {
								const IconComponent = option.icon;
								return (
									<div
										key={option.id}
										className={`icon-option ${selectedIcon === option.id ? 'selected' : ''}`}
										onClick={() => this.handleIconSelect(option.id)}
									>
										<IconComponent className="icon" />
										<span className="icon-name">{option.name}</span>
									</div>
								);
							})}
						</div>
					</div>

					<div className="modal-actions d-flex justify-content-end gap-2">
						<button
							type="button"
							className="btn btn-outline-primary"
							onClick={this.props.handleClose}
							disabled={loading}
						>
							{t("common.cancel")}
						</button>
						<button
							type="submit"
							className="btn btn-primary ml-3"
							disabled={loading || !name.trim()}
						>
							{loading
								? (editMode ? t("documents.folder.updating") : t("documents.folder.creating"))
								: (editMode ? t("documents.folder.update") : t("documents.folder.create"))}
						</button>
					</div>
				</form>
			</div>
		);
	}
}

export default withTranslation()(CreateFolderModal); 